// import { Box, Text, theme } from "@aksara-ui/react";
import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import React from "react";

import { setTitle } from "utilities/helper/setTitle";
// import { ReactComponent as Illustration } from "assets/images/loader.svg";
import DashboardContent from "modules/Dashboard";

const DashboardPage: React.FC = () => {
  setTitle("Dashboard");
  return (
    <Auth>
      <Layout>
        <DashboardContent />
      </Layout>
    </Auth>
  );
};

export default DashboardPage;
